<template>
	<div>
		<div>
			<!-- <div class="label">Buscar o crear cliente</div> -->
			<v-select
				class="select"
				:options="options"
				placeholder="Buscar ubicación"
				@search="search"
				@input="selected"
				label="id"
				:value="location"
				:filterable="false"
				:clearable="false"
			>
				<template #selected-option="option">
					<div style="selected">
						<span>{{ option.name }} </span>
						<em style="margin-left: .5rem;">{{ option.address }}</em>
					</div>
				</template>
				<template #list-header>
					<div class="create-new" @click="open">
						<i class="icon icon-plus mr-2"></i> Crear ubicación nueva
					</div>
				</template>
				<template #no-options>
					<div></div>
				</template>

				<template #option="option">
					<div class="item">
						<strong>{{ option.name }}</strong
						><br />
						<em>{{ option.address }}</em>
					</div>
				</template>
			</v-select>
		</div>

		<b-modal id="locationModal" title="Crear ubicación" no-close-on-backdrop hide-footer>
			<LocationForm @updated="selected" @created="selected" @close="close()" />
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"

import LocationForm from "@/views/locations/LocationForm"

export default {
	components: {
		LocationForm
	},
	props: {
		value: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			location: null,
			options: [],
			loading: false
		}
	},
	beforeMount() {
		console.log(this.value)
		this.location = this.value
	},
	methods: {
		open() {
			this.$bvModal.show("locationModal")
		},
		close() {
			this.$bvModal.hide("locationModal")
		},

		selected(val) {
			this.location = val
			this.close()
			this.$emit("updated", this.location)
		},
		unselect() {
			this.location = null
			this.$emit("updated", this.location)
		},

		search(searchText) {
			if (searchText != "") {
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $search: String) {
								eventLocations(take: $take, skip: $skip, search: $search) {
									data {
										id
										name
										address
										latlng {
											lat
											lng
										}
										locality {
											id
											name
											region {
												id
												name
											}
										}
									}
								}
							}
						`,
						variables: {
							take: 10,
							skip: 0,
							search: searchText
						},
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.options = data.eventLocations.data

						this.loading = false
					})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.select /deep/ .vs__dropdown-toggle {
	border: solid 1px #d8d8d8;
	background-color: #fff;
	border-radius: 4px;
	min-height: 50px;
}

.select /deep/ .vs-_open-indicator {
	border-top: 4px solid #c9c9c9;
}
</style>
